





































import { defineComponent, PropType } from '@nuxtjs/composition-api';
import { computePosition, offset, flip, shift, arrow } from '@floating-ui/dom';
import { SfIcon } from '@storefront-ui/vue';
import useWindowResize from '~/hooks/useResizeWindow';

type TooltipColor = 'grey' | 'gray' | 'orange' | null;

export default defineComponent({
  name: 'Tooltip',
  components: { SfIcon },
  props: {
    small: { type: Boolean, default: false },
    content: { type: String, default: '' },
    color: { type: String as PropType<TooltipColor>, default: 'orange' }
  },
  setup() {
    const { isDesktop } = useWindowResize();

    return {
      isDesktop
    };
  },
  methods: {
    toogleTooltip() {
      const tooltipEl: HTMLElement = this.$refs.tooltipContent;
      if (this.isHidden(tooltipEl)) {
        this.showTooltip(tooltipEl);
      } else {
        this.hideTooltip(tooltipEl);
      }
    },
    hideTooltip(element: HTMLElement) {
      element.classList.add('hidden');
      element.classList.remove('visible');
    },
    showTooltip(tooltipEl: HTMLElement) {
      tooltipEl.classList.add('visible');
      tooltipEl.classList.remove('hidden');
      this.setUpTooltip(tooltipEl);
    },
    setUpTooltip(tooltipEl: HTMLElement) {
      // define position of the tooltip and control style of the arrow of the tooltip
      const buttonEl = this.$refs.sfTooltipIcon.$el;
      const arrowEl = this.$refs.tooltipArrow;

      computePosition(buttonEl, tooltipEl, {
        placement: this.isDesktop ? 'right' : 'top',
        middleware: [
          offset(8),
          flip(),
          shift({ padding: 4 }),
          arrow({ element: arrowEl })
        ]
      }).then(({ x, y, placement, middlewareData }) => {
        Object.assign(tooltipEl.style, {
          left: `${x}px`,
          top: `${y}px`
        });

        const { x: arrowX, y: arrowY } = middlewareData.arrow;
        const staticSide = {
          top: 'bottom',
          right: 'left',
          bottom: 'top',
          left: 'right'
        }[placement.split('-')[0]];

        const arrowStyle = {
          left: arrowX !== null ? `${arrowX}px` : '',
          top: arrowY !== null ? `${arrowY}px` : '',
          right: '',
          bottom: '',
          [staticSide]: '-5px'
        };
        Object.assign(arrowEl.style, arrowStyle);
      });
    },
    isHidden(element) {
      const style = window.getComputedStyle(element);
      return style.display === 'none';
    },
    enableMouseLeave() {
      const small = this.$props.small;
      return small || (!small && this.isDesktop);
    }
  }
});
